import { render, staticRenderFns } from "./CardWithExpandableContent.vue?vue&type=template&id=92296f00&"
import script from "./CardWithExpandableContent.vue?vue&type=script&lang=ts&"
export * from "./CardWithExpandableContent.vue?vue&type=script&lang=ts&"
import style0 from "./CardWithExpandableContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports